<template>
  <div v-if="menuIsOpen" id="wrapper-lu-column-menu" class="mhv-100 h-100 d-flex flex-column" :class="{'menu-collpased': collapsedMode}" v-click-outside="mutationIsOpen" :style="cssVars">
    <router-link to="/" class="logo text-center">
      <b-img :src="logoImgShowed" alt="Logo 1" style="width: 100%"></b-img>
    </router-link>
    <ul id="menu-collapse" class="my-0" :class="noBorderWhenCollapsed">
      <b-nav-item
        v-if="collapsedMode"
        class="mb-4"
        @click="collapsedModeToggle"
        v-b-popover="{ content: 'Desplegar Menú', placement: 'right', customClass: 'ml-2', disabled: !collapsedMode, trigger: 'hover', boundary: 'viewport' }"
      >
        <div class="d-flex align-items-center" :class="{ 'justify-content-center': collapsedMode }">
          <!-- <i class="dripicons-chevron-right d-flex"></i> -->
          <b-icon-chevron-double-right font-scale="1" variant="white"></b-icon-chevron-double-right>
        </div>
      </b-nav-item>
      <div
        v-if="!collapsedMode"
        class="d-flex justify-content-end"
        v-b-popover="{ content: 'Menú', placement: 'right', customClass: 'ml-4', disabled: !collapsedMode, trigger: 'hover', boundary: 'viewport' }"
      >
        <div class="d-flex justify-content-end p-2" :class="{ 'justify-content-center': collapsedMode }" style="cursor: pointer;" @click="collapsedModeToggle">
          <b-icon-chevron-double-left font-scale="1.5" variant="white"></b-icon-chevron-double-left>
        </div>
      </div>
    </ul>
    <ul id="menu-list" role="tablist" class="px-2 my-0" v-if="!isLoading">
      <b-nav-item
        :to="el.path"
        :href="el.href"
        :target="el.newTab ? '_blank' : null"
        class="my-3 w-100"
        exact-active-class="active-item"
        v-for="(el, index) in userOptionMenu"
        :key="index"
        v-b-popover="{ content: el.name, placement: 'right', customClass: 'ml-3', disabled: !collapsedMode, trigger: 'hover', boundary: 'viewport' }"
      >
        <template v-if="el.parent">
          <div
            class="d-flex align-items-center"
            :class="{ 'justify-content-center': collapsedMode }"
            v-b-toggle="el.id"
            @click="onExpandParentMenuPoint"
          >
            <i :class="el.icon" class="d-flex"></i>
            <span v-if="!collapsedMode" class="ml-3">{{ el.name }}</span>
            <i
              v-if="!collapsedMode"
              class="d-flex dripicons ml-2"
              :class="[el.collapsed ? 'dripicons-chevron-right' : 'dripicons dripicons-chevron-down']"
            ></i>
          </div>
          <b-collapse
            tag="ul"
            :id="el.id"
            accordion="accordion-app"
            role="tabpanel"
            class="side-nav-second-level mt-4"
            v-if="!collapsedMode"
            @input="el.collapsed = $event"
          >
            <b-nav-item
              :to="child.path"
              class="my-2 w-100"
              exact-active-class="active-item"
              v-for="(child, index) in el.childs"
              :key="index"
            >
              <div class="d-flex align-items-center">
                <i v-if="child.icon" :class="child.icon" class="d-flex mr-3"></i>
                <span >{{ child.name }}</span>
              </div>
            </b-nav-item>
          </b-collapse>
        </template>
        <template v-if="!el.parent">
          <div class="d-flex align-items-center" :class="{ 'justify-content-center': collapsedMode }">
            <i :class="el.icon" class="d-flex"></i>
            <span v-if="!collapsedMode" class="ml-3">{{ el.name }}</span>
          </div>
        </template>
      </b-nav-item>
    </ul>
    <template v-else>
      <div class="d-flex flex-column align-items-end px-2 pt-4" style="gap: 1rem">
        <b-skeleton type="button" class="w-100" v-for="(item, index) in 4" :key="index"></b-skeleton>
      </div>
    </template>
    <div
      class="d-flex align-items-center px-2 flex-grow-1 cfg-nav-item"
      :class="noBorderWhenCollapsed"
      v-if="configurationOptionMenu && !isLoading"
    >
      <b-nav-item
        v-if="collapsedMode"
        exact-active-class="active-item"
        v-b-popover="{ content: configurationOptionMenu.name, placement: 'right', customClass: 'ml-3', disabled: !collapsedMode, trigger: 'hover', boundary: 'viewport'  }"
        @click="toggleDropdown"
        class="w-100 d-flex justify-content-center align-items-center"
        style="list-style-type: none;"
      >
        <i :class="configurationOptionMenu.icon"></i>
      </b-nav-item>
      <b-nav-item-dropdown
        class="w-100"
        dropright
        ref="ddown"
        boundary="viewport"
        no-caret
        v-if="!collapsedMode"
        @input="configurationOptionMenu.collapsed = $event"
        :text="configurationOptionMenu.name"
        variant="transparent"
        menu-class="dropdown-scroll-menu position-fixed"
        style="list-style-type: none;"
      >
        <template #button-content>
          <div class="d-flex align-center">
            <i :class="configurationOptionMenu.icon" class="d-flex align-items-center"></i>
            <span v-if="!collapsedMode" class="ml-3">{{ configurationOptionMenu.name }}</span>
            <i class="dripicons dripicons-chevron-right ml-2 d-flex align-items-center"></i>
          </div>
        </template>
        <b-dropdown-item
          :to="child.path"
          class="my-2"
          exact-active-class="active-item"
          v-for="(child, index) in configurationOptionMenu.childs"
          :key="index"
          style="list-style-type: none;"
        >
          <div class="d-flex align-items-center text-white font-weight-light">
            <i v-if="child.icon" :class="child.icon" class="d-flex mr-3"></i>
            <span >{{ child.name }}</span>
          </div>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapState, mapMutations, mapActions } from 'vuex'
import '@/directives/click-outside.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
library.add(faAngleDoubleLeft, faAngleDoubleRight)
export default {
  data () {
    return {
      collapsedMode: false,
      menuItemsData: []
    }
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    externalExpanded: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('settings', ['logoImg', 'collapsedLogoImg', 'menuBgColor', 'menuFontColor', 'menuActiveFontColor', 'menuHoverBgColor', 'logoAlignItems', 'logoJustifyContent', 'logoWidth', 'logoPadding']),
    ...mapState('menu', ['menuIsOpen']),
    collapseIcon () {
      return this.collapsedMode ? 'angle-double-right' : 'angle-double-left'
    },
    logoImgShowed () {
      return this.collapsedMode ? this.collapsedLogoImg : this.logoImg
    },
    cssVars () {
      return {
        '--menu-bg-color': this.menuBgColor,
        '--menu-font-color': this.menuFontColor,
        '--active-menu-font-color': this.menuActiveFontColor,
        '--menu-hover-bg-color': this.menuHoverBgColor,
        '--logo-align-items': this.logoAlignItems,
        '--logo-justify-content': this.logoJustifyContent,
        '--logo-width': this.logoWidth,
        '--logo-padding': this.logoPadding
      }
    },
    configurationOptionMenu () {
      if (this.menuItemsData.length) {
        const configurationMenu = this.menuItemsData.filter(menu => menu.id === 'configuracion')
        return configurationMenu[0]
      } else {
        return null
      }
    },
    userOptionMenu () {
      if (this.menuItemsData.length) {
        const menu = this.menuItemsData.filter(menu => menu.id !== 'configuracion')
        return menu
      } else {
        return null
      }
    },
    noBorderWhenCollapsed () {
      if (!this.collapsedMode) {
        return 'div-border'
      }
    }
  },
  methods: {
    ...mapMutations('menu', ['mutationIsOpen']),
    ...mapActions('menu', ['menuOnResize']),
    collapsedModeToggle () {
      // Oculto todos los popovers
      this.$root.$emit('bv::hide::popover')
      this.collapsedMode = !this.collapsedMode
      this.$emit('expanded', !this.collapsedMode)
    },
    onExpandParentMenuPoint () {
      // Oculto todos los popovers
      this.$root.$emit('bv::hide::popover')
      this.collapsedMode = false
      this.$emit('expanded', true)
    },
    horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside () {
      this.menuItemsData = []
      this.menuItemsData = this.menuItems.map(item => {
        return {
          collapsed: false,
          ...item
        }
      })
    },
    isVisible (menuPath) {
      return menuPath.some(el => '/' + el?.path.split('/')[1] === this.$route.matched[1]?.path)
    },
    toggleDropdown () {
      if (this.collapsedMode) {
        this.collapsedModeToggle()
        setTimeout(() => {
          this.$refs.ddown.visible = true
        }, 500)
      } else {
        this.$refs.ddown.visible = true
      }
    }
  },
  directives: {
    ClickOutside
  },
  watch: {
    externalExpanded (val) {
      this.collapsedMode = !val
    },
    '$route.path' () {
      this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
    },
    menuItems () {
      this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
    }
  },
  mounted () {
    this.menuOnResize()
    this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
  }
}
</script>
<style lang="sass">
#wrapper-lu-column-menu
  max-width: 265px
  background: var(--menu-bg-color)
  font-size: .95rem
  max-height: 100vh
  @media(max-width: $xl)
    position: fixed
    z-index: 10
    overflow-x: hidden
  a,
  .side-nav-item
    color: var(--menu-font-color)
  button
    color: var(--menu-font-color)
    font-size: 15px
    &:hover
      color: white
      text-decoration: none
  .logo
    display: none
  .img-logo
    width: var(--logo-width)
    height: auto
  .active-item
    border-radius: 8px
    background-color: rgba(41, 41, 41, 0.6)
  .dropdown-button-text
    font-size: .95rem
  &.menu-collpased
    .logo
      display: none
    #menu-list
      height: calc(100vh - 44px - 42px)
  // menu-list tiene el 100vh menos el alto del logo y la configuracion
  #menu-list
    height: calc(100vh - 44px - 42px)
    overflow-x: hidden
    overflow-y: auto
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-track
      background: transparent
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: #888
    &::-webkit-scrollbar-thumb:hover
      background: #555
  .div-border
    border-top: 1px solid rgba(152,166,173,.2)
  .cfg-nav-item
    .nav-link
      &:hover
        background: none
  .nav-link
    &:hover
      background-color: var(--menu-hover-bg-color)
      border-radius: 8px
  .dropdown-scroll-menu
    z-index: $zIndexLmDropdownMenu
    top: 5px !important
    background-color: var(--menu-bg-color)
    max-height: 80vh
    overflow-y: auto
    padding: .5rem
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-track
      background: var(--menu-bg-color)
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: #888
    &::-webkit-scrollbar-thumb:hover
      background: #555
    .dropdown-item
      padding: .5rem 1rem
      &:hover
        background-color: var(--menu-hover-bg-color)
        border-radius: 8px
      &:focus
        background: none
  // Hide internal collapse control; we control it from header
  #menu-collapse
    display: none
</style>
